module.exports = __webpack_public_path__ + "static/media/exibex1.a2b33d1e.gif";